module.exports = __webpack_public_path__ + "static/media/yb-logo.ec2778cc.jpg";